<template>

  <dialog_wheelDateChooser @submit="handleDateSubmit" v-if="datePickerShow" :default-date="tempDateForWheel" />
  <dialog_wheelTimeChooser @submit="handleTimeSubmit" v-if="timePickerShow" :default-time="tempTimeForWheel" />

  <div class="inner-dialog" v-if="innerDialogTarget">
    <span class="cls" @click="innerDialogTarget = null;"></span>
    <div class="paper TodoMenu" v-if="innerDialogTarget == 'TodoMenu'">
      <ul>
        <li @click="editTodo(editTodoTemp)"> <div> <i class="ph-fill ph-pencil-simple"></i> </div> <span>수정</span> </li>
        <!-- <li> <div> <i></i> </div> <span>반복</span> </li> -->
        <li @click="deleteTodo"> <div> <i class="ph-fill ph-trash"></i> </div> <span>삭제</span> </li>
      </ul>
    </div>
  </div>

  <div class="dialog">
    <span class="cls" @click="oth_showTodoEdit(false)"></span>
    <div class="paper">
      <div class="header"> <h2>할일 리마인더</h2> <span @click="oth_showTodoEdit(false)"> <i class="ph ph-x"></i></span> </div>
      <div class="week-calendar">
        <span>2025. 07</span>
        <ul>
          <li v-for="(item, index) in thisWeek" :key="index" :class="{ today: item.today, select: item.date == selectDate }" @click="getTodos(item.date)">
            <span>{{ item.date.slice(8, 10) }}</span>
            <span>{{ item.day }}</span>
          </li>
        </ul>
      </div>
      <div class="status">
        <button @click="makeTodo">할일 만들기<span><i class="ph ph-plus"></i></span></button>
      </div>
      <div class="content">
        <ul>
          <li v-for="(todo, index) in todoList" :key="index">
            <a @click="todoOnOff(todo)" :class="{ check: todo.is_completed}"> <i v-if="todo.is_completed == 1" class="ph-bold ph-check"></i> </a>
            <input @click="editingTodo != todo ? openTodoMenu(todo) : null" @blur="onBlur" type="text" :readonly="editingTodo != todo" v-model="todo.title" :class="{ editing: editingTodo == todo }" />
            <p @click="useTimePicker(true, todo, todo.time)">{{todo.time_display}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>


<script>
import { inject, ref } from "vue"

import dialog_wheelDateChooser from '@/components/dialogs/wheelDateChooser.vue';
import dialog_wheelTimeChooser from '@/components/dialogs/wheelTimeChooser.vue';
import { useBackButton } from '@/utils/useBackBtn';


export default {
  components: {
    dialog_wheelDateChooser,
    dialog_wheelTimeChooser,
  },
  props:{
    oth_showTodoEdit:Function
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const getMbid = inject('getMbid');

    const todoList = ref([]);
    const innerDialogTarget = ref(null);

    const datePickerShow = ref(false);
    const timePickerShow = ref(false);
    const tempDateForWheel = ref('');
    const tempTimeForWheel = ref('');

    const selectDate = ref('');
    const todayDate = new Date().getDate() // 예: 30
    const thisWeek = getThisWeek();
    const editingTodo = ref(null);
    const editTodoTemp =  ref(null);

    
    useBackButton(() => {
      props.oth_showTodoEdit(false);
    });

    let formattedDate = new Date().toISOString().split('T')[0];

    function useTimePicker(b, todo, time) {
      if (!editingTodo.value || editingTodo.value != todo) {
        editingTodo.value = todo;
      }
      timePickerShow.value = b;
      tempTimeForWheel.value = time;
    }

    async function handleTimeSubmit({ hour, minute }) {
      if (!editingTodo.value) {
        console.error('editingTodo.value가 null입니다.');
        timePickerShow.value = false;
        editingTodo.value = null;
        return;
      }

      if (hour === null || minute === null) {
        editingTodo.value.time = null;
        timePickerShow.value = false;
        editingTodo.value = null;
        return;
      }

      const new_time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      editingTodo.value.time = new_time;
      let new_due_date = `${editingTodo.value.date} ${new_time}:00`;
      let sql =`UPDATE todos SET due_date = '${new_due_date}' WHERE idx = ${editingTodo.value.idx};`;
      await sql_query(sql);
      console.log('새로운 시간:', sql);
      timePickerShow.value = false;
      editingTodo.value = null;
      await getTodos(formattedDate);
    }

    function getThisWeek() {
      const today = new Date()
      const dayOfWeek = today.getDay() // 일:0 ~ 토:6
      const startOfWeek = new Date(today)

      // 일요일로 이동
      startOfWeek.setDate(today.getDate() - dayOfWeek)

      const weekDays = ['일', '월', '화', '수', '목', '금', '토']

      const thisWeek = Array.from({ length: 7 }, (_, i) => {
        const d = new Date(startOfWeek)
        d.setDate(startOfWeek.getDate() + i)

        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        const dateString = `${yyyy}-${mm}-${dd}`

        return {
          date: dateString,               // ✅ 화면 출력 및 쿼리에 모두 사용 가능
          day: weekDays[d.getDay()],      // 요일
          today: d.toDateString() === today.toDateString(),
        }
      })

      return thisWeek
    }

    function openInnerDialog(target) {
      innerDialogTarget.value = target;
      if (!target) { editTodoTemp.value = null; }
    }

    function editTodo(todo) {
      editingTodo.value = todo;
      openInnerDialog(null);
    }

    async function getTodos(date) {
      selectDate.value = date;
      const query = `SELECT * FROM todos WHERE mb_id = '${getMbid()}' AND DATE(due_date) = '${date}'`;
      let res = await sql_query(query);
      if (res.length === 0) {
        todoList.value = [];
        return;
      }
      res.forEach(item => {
        const isoString = item.due_date; // 예: "2025-07-30T18:00:00.000Z"

        const [datePart, timePart] = isoString.split('T'); // ["2025-07-30", "18:00:00.000Z"]
        const [hourRaw, minuteRaw] = timePart.split(':'); // "18", "00"

        const yyyy = datePart.split('-')[0];
        const mm = datePart.split('-')[1];
        const dd = datePart.split('-')[2];

        const hour = parseInt(hourRaw, 10);
        const minute = minuteRaw;
        const ampm = hour < 12 ? '오전' : '오후';
        const displayHour = String(hour % 12 || 12).padStart(2, '0');

        item.date = `${yyyy}-${mm}-${dd}`;
        item.time = `${hourRaw}:${minute}`;
        item.time_display = `${ampm} ${displayHour}:${minute}`;
      });

      // ✅ 시간순 정렬 추가
      res.sort((a, b) => {
        if (!a.time) return 1;
        if (!b.time) return -1;
        return a.time.localeCompare(b.time);
      });

      todoList.value = res;
    }
    getTodos(formattedDate);

    function todoOnOff(todo) {
      todo.is_completed = todo.is_completed === 1 ? 0 : 1;
      sql_query(`UPDATE todos SET is_completed = ${todo.is_completed} WHERE idx = ${todo.idx}`);

      const aScore = Number(todo.activity_score) || 5;
      if (aScore > 0) {
        if (todo.is_completed === 1) {
          sql_query(`INSERT INTO activity_score_log (mb_id, score, source_type, source_idx, reason, created_at) VALUES ('${getMbid()}', ${aScore}, 'todo', ${todo.idx}, '${(todo.title||"").replace(/'/g,"''")} 완료', NOW())`);
        } else {
          sql_query(`DELETE FROM activity_score_log WHERE mb_id='${getMbid()}' AND source_type='todo' AND source_idx=${todo.idx} ORDER BY idx DESC LIMIT 1`);
        }
      }
    }

    function openTodoMenu(todo) {
      editTodoTemp.value = todo;
      openInnerDialog('TodoMenu');
    }

    async function onBlur() {
      if (!editingTodo.value) return;
      await sql_query(`UPDATE todos SET title = '${editingTodo.value.title}' WHERE idx = ${editingTodo.value.idx}`);
      editingTodo.value = null;
    }

    async function deleteTodo() {
      let ask = confirm('정말로 삭제하시겠습니까?');
      if (!ask) return;
      await sql_query(`DELETE FROM todos WHERE idx = ${editTodoTemp.value.idx}`);
      await getTodos(formattedDate);
      innerDialogTarget.value = null;
    }

    async function makeTodo() {
      const sql = `INSERT INTO todos set title = '새 할일', mb_id = '${getMbid()}', due_date = '${selectDate.value}', is_completed = 0, created_at = NOW(), updated_at = NOW();`;
      await sql_query(sql);
      await getTodos(formattedDate);
      innerDialogTarget.value = null;
    }

    return {
      sql_query,
      datePickerShow,
      timePickerShow,
      tempDateForWheel,
      tempTimeForWheel,
      todayDate,
      thisWeek,
      todoList,
      todoOnOff,
      getTodos,
      selectDate,
      editingTodo,
      editTodo,
      innerDialogTarget,
      openTodoMenu,
      editTodoTemp,
      onBlur,
      deleteTodo,
      makeTodo,
      useTimePicker,
      handleTimeSubmit
    }
  }
}
</script>


<style scoped>
#dialog-menu-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.inner-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.inner-dialog > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.inner-dialog > .paper {
  width: 90%;
  max-width: 480px;
  min-height: 10%;
  height:fit-content;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.inner-dialog > .paper.TodoMenu > ul {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.inner-dialog > .paper.TodoMenu > ul > li {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.inner-dialog > .paper.TodoMenu > ul > li > div {
  width: var(--font-size-3xl);
  height: var(--font-size-3xl);
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-brand);
  border-radius: 50%;
  font-size:var(--font-size-xl);
  color:var(--color-text-black);
}

ul.suggestion  {
  display:flex;
  display:none;
  position: absolute;
  width:40%;
  left:0;
  top:0;
  height: fit-content;
  max-height:300px;
  max-width:400px;
  overflow-y: scroll;
  flex-direction: column;
  gap: 6px;
  padding:12px;
  box-sizing: border-box;
  background: var(--color-background-light);
  border-radius: 8px;
  z-index: 999;
}

ul.suggestion > li {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  padding:6px;
  box-sizing: border-box;
  border-radius:6px;
  cursor:pointer;
}

.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width:600px;
  height: 80%;
  background: var(--color-background);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:24px;
  display:flex;
  flex-direction: column;
}

.header {
  width:100%;
  height:var(--font-size-3xl);
  display:flex;
  justify-content: space-between;
  align-items:center;
}

.header > h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.header > span {
  width:var(--font-size-3xl);
  height:var(--font-size-3xl);
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.header > span > i {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

.week-calendar {
  width:100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
  gap:12px;
}

.week-calendar > span {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.week-calendar > ul {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items:center;
  padding:0;
  margin:0;
  list-style:none;
  gap:var(--font-size-sm);
}

.week-calendar > ul > li {
  width:100%;
  flex:1;
  height:fit-content;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--color-background-light);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  padding:var(--font-size-sm);
  border-radius: 12px;
  cursor: pointer;
  border:2px solid transparent;
}

.week-calendar > ul > li.today {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.week-calendar > ul > li.select {
  border:2px solid var(--color-brand);
}

.status {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: start;
  align-items: center;
}

.status > button {
  width:fit-content;
  height: fit-content;
  padding:6px 12px;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:8px;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  border:none;
  border-radius:100px;
  cursor:pointer;
}

.status > button > span {
  width:var(--font-size-lg);
  height:var(--font-size-lg);
  background:var(--color-background);
  color:var(--color-text-primary);
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding:4px;
  font-size: var(--font-size-md);
}

.content {
  width:100%;
  flex:1;
  height:100%;
  display:flex;
}

.content > ul {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:12px;
  padding:0;
  margin:0;
  list-style:none;
  box-sizing: border-box;
}

.content > ul > li {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: center;
  align-items: center;
  background: var(--color-background-light);
  padding:12px;
  gap:12px;
  border-radius: 8px;
  box-sizing: border-box;
}

.content > ul > li > a {
  width:var(--font-size-2xl);
  height:var(--font-size-2xl);
  display:flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 2px solid var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  border-radius:50%;
  cursor: pointer;
}

.content > ul > li > a.check {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.content > ul > li > input {
  flex:1;
  height:100%;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  border:none;
  background:transparent;
}

.content > ul > li > input:focus {
  outline:none;
  border-bottom:none;
}

.content > ul > li > input.editing {
  border-bottom:1px solid var(--color-brand);
}

.content > ul > li > p {
  height:100%;
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  margin:0;
  padding:0px 16px;
  background: var(--color-surface-reverse);
  border-radius: 50px;
  display:flex;
  justify-content: center;
  align-items: center;
}

</style>
